import { NavigationPage } from '@/app/components'
import { useNavigation } from '@/app/hooks'
import { Card, NavigationList } from '@/components'
import teslaPowerwallImageSrc from '@/authenticated/images/tesla.webp'
import useViewModel, { DestinationBrand } from './useViewModel'
import SurveyObserver from '@/app/components/SurveyObserver'

const devices = [
  {
    id: 'tesla-powerwall',
    name: 'Tesla',
    logo: teslaPowerwallImageSrc,
    brand: DestinationBrand.Tesla,
    destination: undefined,
  },
]

function LoadingContent() {
  return null
}

function LoadedContent({
  onSelect,
}: {
  onSelect: (destination: string | DestinationBrand) => void
}) {
  return (
    <Card className="py-0">
      <NavigationList>
        {devices.map((device, index) => (
          <NavigationList.BasicItem
            key={`${device.name}-${index}`}
            id={`${device.id}-nav-item`}
            label={device.name}
            variant="image"
            imgSrc={device.logo}
            onClick={() => onSelect(device.brand)}
            labelClasses="!text-base pl-4 self-start flex self-center"
          />
        ))}
        <SurveyObserver observedSurveys={['MissingBrand']}>
          <NavigationList.BasicItem
            key="i-dont-see-my-brand"
            id="i-dont-see-my-brand-nav-item"
            variant="character"
            character="?"
            label="I don't see my brand"
            onClick={() => onSelect('not-found')}
            labelClasses="!text-base pl-4 self-start flex self-center"
            characterClasses="self-center flex self-start m-auto"
          />
        </SurveyObserver>
      </NavigationList>
    </Card>
  )
}

export default function SelectEnergySystemDevicePage() {
  const { getSelectDestination, isLoading, error } = useViewModel()
  const navigation = useNavigation()

  const onSelect = (brandOrDestination: DestinationBrand | string) => {
    navigation.push(getSelectDestination(brandOrDestination))
  }

  return (
    <NavigationPage id="connect-device-page" title="Select your brand">
      {isLoading ? <LoadingContent /> : <LoadedContent onSelect={onSelect} />}
    </NavigationPage>
  )
}
